import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        console.log('🚀 NUCLEAR ScrollToTop: Path changed to', pathname);

        const nuclearScrollToTop = () => {
            console.log('💥 Executing nuclear scroll to top...');

            // Method 1: Direct window scrolling
            window.scrollTo(0, 0);

            // Method 2: With options
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'instant' as any
            });

            // Method 3: All possible elements
            const allElements = document.querySelectorAll('*');
            allElements.forEach(element => {
                if (element instanceof HTMLElement && element.scrollTop > 0) {
                    console.log(`Scrolling element:`, element);
                    element.scrollTop = 0;
                }
            });

            // Method 4: Document elements
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;

            // Method 5: Force via style (emergency)
            document.documentElement.style.scrollBehavior = 'auto';
            document.body.style.scrollBehavior = 'auto';

            // Method 6: Emergency timeout
            setTimeout(() => {
                window.scrollTo(0, 0);
                document.documentElement.scrollTop = 0;
                document.body.scrollTop = 0;
            }, 100);

            console.log('✅ Nuclear scroll completed');
        };

        nuclearScrollToTop();

        const timer1 = setTimeout(nuclearScrollToTop, 10);
        const timer2 = setTimeout(nuclearScrollToTop, 100);
        const timer3 = setTimeout(nuclearScrollToTop, 500);

        return () => {
            clearTimeout(timer1);
            clearTimeout(timer2);
            clearTimeout(timer3);
        };
    }, [pathname]);

    return null;
};

export default ScrollToTop;